<div class="about-page" #aboutRoot>
  <app-about-hero-section [aboutValues]="aboutValues"></app-about-hero-section>
  <app-about-unique-section [uniqueStats]="uniqueStats"></app-about-unique-section>
  <app-about-industries-section [industries]="industries"></app-about-industries-section>
  <app-about-why-section [reasons]="reasons"></app-about-why-section>
  <app-about-pillars-section [pillars]="pillars"></app-about-pillars-section>
  <app-about-final-cta-section></app-about-final-cta-section>
</div>
